/** Client wait time for bulk ZIP/Excel imports (upload + server processing). */
export const BULK_IMPORT_CLIENT_TIMEOUT_MS = 15 * 60 * 1000;

export const isBulkImportUploadUrl = (url) => {
  const path = String(url || "");
  return (
    path.includes("/bulk-upload-zip") ||
    path.includes("/bulk-upload") ||
    path.includes("bulk-upload-zip") ||
    path.includes("bulk-upload")
  );
};

export const applyBulkImportTimeout = (config) => {
  if (!config || !isBulkImportUploadUrl(config.url)) return config;
  const current = config.timeout;
  if (current == null || current < BULK_IMPORT_CLIENT_TIMEOUT_MS) {
    config.timeout = BULK_IMPORT_CLIENT_TIMEOUT_MS;
  }
  config.maxBodyLength = Infinity;
  config.maxContentLength = Infinity;
  return config;
};
